export default __webpack_public_path__ + "static/media/rw.9b86cdb0.svg";